import { uniqueId } from 'lodash';
import { RestaurantDayOff } from 'lib/types/global';
import { DaysOffAction } from './actions';

export interface DaysOffState {
  daysOff: Array<RestaurantDayOff>;
  loadingError?: null | string;
  loading?: boolean;
  saving?: boolean;
  savingError?: string;
  deleting?: boolean;
  deletingError?: string;
}

const initialState: DaysOffState = {
  daysOff: [],
  loading: false,
  saving: false,
  deleting: false,
};

const daysOffReducer = (
  state: DaysOffState = initialState,
  action: DaysOffAction,
): DaysOffState => {
  switch (action.type) {
    case 'GET_DAYS_OFF_REQUEST': {
      return {
        ...state,
        loading: true,
        loadingError: '',
      };
    }

    case 'GET_DAYS_OFF_SUCCESS': {
      const newDaysOff: Array<RestaurantDayOff> = action.payload.map(
        (dayOff) => {
          const newDayOff: RestaurantDayOff = {
            startDate: new Date(dayOff.start_at),
            endDate: new Date(dayOff.end_at),
            description: dayOff.description,
            branchIds: dayOff.sites,
            daysOffIds: dayOff.days_off_ids,
            referenceKey: uniqueId(),
          };
          return newDayOff;
        },
      );
      const daysOff = [...newDaysOff];
      return {
        ...state,
        daysOff,
        loading: false,
        loadingError: '',
      };
    }

    case 'GET_DAYS_OFF_FAILURE': {
      return {
        ...state,
        loading: false,
        loadingError: 'load_error',
      };
    }

    case 'ADD_DAYS_OFF_REQUEST': {
      return {
        ...state,
        saving: true,
        savingError: '',
      };
    }

    case 'ADD_DAYS_OFF_SUCCESS': {
      return {
        ...state,
        saving: false,
        savingError: '',
      };
    }

    case 'ADD_DAYS_OFF_FAILURE': {
      return {
        ...state,
        saving: false,
        savingError: 'save_error',
      };
    }

    case 'REMOVE_DAYS_OFF_REQUEST': {
      return {
        ...state,
        deleting: true,
        deletingError: '',
      };
    }

    case 'REMOVE_DAYS_OFF_SUCCESS': {
      return {
        ...state,
        deleting: false,
        deletingError: '',
      };
    }

    case 'REMOVE_DAYS_OFF_FAILURE': {
      return {
        ...state,
        deleting: false,
        deletingError: 'delete_failed',
      };
    }

    default:
      return { ...state };
  }
};

export default daysOffReducer;
